import { RegionManager } from 'backbone.marionette';

import PaymentItemView from '../views/paymentitem';

module.exports = function (options) {
  var regions = new RegionManager({
    regions: {
      paymentitem: '#paymentitem-hook'
    }
  });

  regions.get('paymentitem').show(new PaymentItemView(options));
};



// WEBPACK FOOTER //
// ./parentpay/initializers/paymentitem.js